<template>
  <span
    class="flex items-center justify-between h-fit py-2 px-3 bg-success-100 border border-success-200 rounded text-accent-800 font-semibold text-sm"
    :class="[variant]"
  >
    <span
      class="font-caption-1-strong"
      :class="`${variant === 'primary' ? 'mr-2' : 'mr-4'}`"
    >
      {{ label }}
    </span>
    <div
      class="w-[14px] h-[14px] flex items-center justify-center cursor-pointer"
      @click.stop="emit('remove')"
    >
      <font-awesome-icon
        class="w-[12px] h-[12px] text-sm"
        :icon="['far', 'xmark']"
      />
    </div>
  </span>
</template>

<script setup lang="ts">
defineProps({
  label: {
    type: String,
    required: true,
  },
  variant: {
    type: String,
    required: true,
    default: "solid",
  },
});
const emit = defineEmits(["remove"]);
</script>

<style scoped>
.solid {
  @apply bg-gray-200 border-none font-semibold font-['Inter'] leading-none hover:bg-gray-300;
}
.primary {
  @apply h-6 py-[6px] bg-white border border-secondary-700 text-secondary-600;
}
</style>
